const ORDER_STATUS = {
    NEW: 10,
    PENDING: 12,
    DESIGNATED_FOR_PRODUCTION: 13,
    ACCEPTED: 15,
    CLOSED: 50,
    PARTIAL_SENT: 90,
    SENT: 100,
    SUSPENDED: 110,
    CANCELLED: 120,
    REMOVED: 130
} as const

export type OrderStatusId = (typeof ORDER_STATUS)[keyof typeof ORDER_STATUS]

type WmdOrderActionBlockedStatuses = Readonly<{
    SUBMIT: readonly OrderStatusId[]
    COMMENT: readonly OrderStatusId[]
}>

const WMD_ORDER_ACTION_BLOCKED_STATUSES = {
    SUBMIT: [
        ORDER_STATUS.DESIGNATED_FOR_PRODUCTION,
        ORDER_STATUS.ACCEPTED,
        ORDER_STATUS.SUSPENDED,
        ORDER_STATUS.CANCELLED,
        ORDER_STATUS.REMOVED
    ],
    COMMENT: [ORDER_STATUS.DESIGNATED_FOR_PRODUCTION, ORDER_STATUS.REMOVED]
} as WmdOrderActionBlockedStatuses

type WmdOrderDetailsActionAllowedStatuses = Readonly<{
    SUBMIT: readonly OrderStatusId[]
    CANCEL: readonly OrderStatusId[]
    COMPLAINT: readonly OrderStatusId[]
    PRIORITY: readonly OrderStatusId[]
    REPORT_COMPLAINT: readonly OrderStatusId[]
}>

const WMD_ORDER_DETAILS_ACTION_ALLOWED_STATUSES = {
    SUBMIT: [ORDER_STATUS.NEW],
    CANCEL: [ORDER_STATUS.ACCEPTED],
    COMPLAINT: [ORDER_STATUS.NEW],
    PRIORITY: [ORDER_STATUS.NEW],
    REPORT_COMPLAINT: [ORDER_STATUS.ACCEPTED]
} as WmdOrderDetailsActionAllowedStatuses

type WmdOrderDetailsActionBlockedStatuses = Readonly<{
    UPDATE: readonly OrderStatusId[]
    UPDATE_PLANNED_SEND_DATE: readonly OrderStatusId[]
}>

const WMD_ORDER_DETAILS_ACTION_BLOCKED_STATUSES = {
    UPDATE: [ORDER_STATUS.DESIGNATED_FOR_PRODUCTION, ORDER_STATUS.ACCEPTED, ORDER_STATUS.CANCELLED, ORDER_STATUS.REMOVED],
    UPDATE_PLANNED_SEND_DATE: [
        ORDER_STATUS.DESIGNATED_FOR_PRODUCTION,
        ORDER_STATUS.SUSPENDED,
        ORDER_STATUS.CANCELLED,
        ORDER_STATUS.REMOVED
    ]
} as WmdOrderDetailsActionBlockedStatuses

export const ORDERS = {
    ORDER_STATUS,
    WMD_ORDER_ACTION_BLOCKED_STATUSES,
    WMD_ORDER_DETAILS_ACTION_ALLOWED_STATUSES,
    WMD_ORDER_DETAILS_ACTION_BLOCKED_STATUSES,
    WMD_MAX_SELECTED_FOR_SUBMIT: 30,
    SHIPMENT_STATUS: {
        NEW: 10,
        SENT: 50
    } as const,
    COOPERATION_ORDER_STATUS: {
        NEW: 10,
        AWAITING_ACCEPTANCE: 20,
        ACCEPTED: 30,
        REJECTED: 40,
        SENT: 100
    } as const,
    COOPERANT_DELIVERY_STATUS: {
        NEW: 10,
        SENT: 50
    } as const,
    ORDER_KIND: {
        ECOMMERCE: 10,
        INTERNAL: 20,
        NON_STANDARD: 30
    } as const,
    /** Internal orders: default numbering scheme when profile does not list allowed type IDs (matches legacy / prod expectation). */
    INTERNAL_ORDER_NUMBER_CONFIGURATION_DEFAULT_NAME: 'CFK' as const,
    INTERNAL_ORDER_NAME_ILLEGAL_CHARACTERS: '/:\'"?*<>|()[]%$#@{}~^&',
    ORDER_PARCEL: {
        PARCEL_MAX_COUNT: 13,
        PARCEL_MIN_WEIGHT: 0.01,
        PARCEL_MAX_WEIGHT: 31.5
    } as const,
    PRODUCTION_FILE_ATTACHMENT_SIZE_MB: 500,
    PRODUCTION_FILE_ATTACHMENT_SIZE_PROOF_MB: 25,
    COOPERANT_MOCKUP: {
        MAX_FILE_SIZE_MB: 15,
        ALLOWED_EXTENSIONS: ['.jpg', '.jpeg'] as const,
        ALLOWED_MIME_TYPES: ['image/jpeg'] as const
    } as const
} as const
